import { Button } from 'lego-on-react';
import React, { useEffect, useState } from 'react';

import { getPublicKey } from '../../../api';
import { Skill } from '../../../model/skill';
import CopyField from '../../CopyField/CopyField';
import { Header } from '../../Form/Form';
import { Loading } from '../../Loading/Loading';
import { publicKeyCaption } from '../descriptions';

interface Props {
    skill: Skill;
}

interface ErrorBlockProps {
    onRetryClick: () => void;
}

const ErrorBlock: React.FC<ErrorBlockProps> = ({ onRetryClick }) => {
    return (
        <div>
            <p>При загрузке публичного ключа произошла ошибка</p>
            <Button theme="action" size="m" onClick={onRetryClick}>
                Повторить
            </Button>
        </div>
    );
};

const PublicKeyField: React.FC<Props> = ({ skill }) => {
    const [publicKey, setPublicKey] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    const loadPublicKey = async () => {
        if (isLoading) {
            return;
        }

        if (isError) {
            setIsError(false);
        }

        setIsLoading(true);

        try {
            setPublicKey(await getPublicKey(skill.id));
        } catch (e) {
            console.error(e);
            setIsError(true);
        } finally {
            setIsLoading(false);
        }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => void loadPublicKey(), []);

    return (
        <div>
            <Header caption={publicKeyCaption}>Получение публичного ключа</Header>
            {isError ? (
                <ErrorBlock onRetryClick={loadPublicKey} />
            ) : !publicKey || isLoading ? (
                <Loading size="m" centered />
            ) : (
                <CopyField label="Публичный ключ" text={publicKey} />
            )}
        </div>
    );
};

export default PublicKeyField;
